import { render, staticRenderFns } from "./MenuConfiguracoes.vue?vue&type=template&id=171c6cbc&scoped=true&"
import script from "./MenuConfiguracoes.vue?vue&type=script&lang=js&"
export * from "./MenuConfiguracoes.vue?vue&type=script&lang=js&"
import style0 from "./MenuConfiguracoes.vue?vue&type=style&index=0&id=171c6cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171c6cbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VDivider,VIcon,VList,VListGroup,VListItem,VListItemAction,VListItemContent,VListItemGroup,VListItemIcon,VListItemTitle})
